(function(){

  function initProductGallerySwipe(gallery, track){
    var stage=gallery.querySelector('.ppc-offer__stage');
    var thumbs=Array.from(gallery.querySelectorAll('.ppc-offer__thumb'));
    var total=track.children.length;
    if(!stage || total<2 || stage.dataset.swipeReady)return;
    stage.dataset.swipeReady='true';
    stage.classList.add('is-draggable');
    var active=thumbs.findIndex(function(thumb){return thumb.classList.contains('is-active');});
    if(active<0)active=0;
    var gesture=null;
    function show(index){
      active=((index%total)+total)%total;
      track.style.transition='';
      track.style.transform='translate3d(-'+(active*100)+'%,0,0)';
      thumbs.forEach(function(thumb,i){
        thumb.classList.toggle('is-active',i===active);
        thumb.setAttribute('aria-pressed',i===active?'true':'false');
      });
      var currentThumb=thumbs[active];
      if(currentThumb && currentThumb.scrollIntoView){
        currentThumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
      }
    }
    function finish(event,cancelled){
      if(!gesture || gesture.id!==event.pointerId)return;
      var current=gesture;
      gesture=null;
      stage.classList.remove('is-dragging');
      track.style.transition='';
      var dx=event.clientX-current.startX;
      var dy=event.clientY-current.startY;
      var changed=!cancelled && Math.abs(dx)>=45 && Math.abs(dx)>Math.abs(dy);
      show(current.index+(changed?(dx<0?1:-1):0));
      if(changed && event.cancelable)event.preventDefault();
    }
    thumbs.forEach(function(thumb,index){
      thumb.addEventListener('click',function(){show(index);});
    });
    var prev=gallery.querySelector('.ppc-offer__arrow--prev');
    var next=gallery.querySelector('.ppc-offer__arrow--next');
    if(prev)prev.addEventListener('click',function(){show(active-1);});
    if(next)next.addEventListener('click',function(){show(active+1);});
    stage.addEventListener('dragstart',function(event){event.preventDefault();});
    stage.addEventListener('pointerdown',function(event){
      if(event.pointerType==='mouse' && event.button!==0)return;
      if(event.target.closest && event.target.closest('.ppc-offer__arrow'))return;
      gesture={id:event.pointerId,startX:event.clientX,startY:event.clientY,index:active};
      stage.classList.add('is-dragging');
      if(stage.setPointerCapture){
        try{stage.setPointerCapture(event.pointerId);}catch(_error){}
      }
    });
    stage.addEventListener('pointermove',function(event){
      if(!gesture || gesture.id!==event.pointerId)return;
      var dx=event.clientX-gesture.startX;
      var dy=event.clientY-gesture.startY;
      if(Math.abs(dx)<=8 || Math.abs(dx)<=Math.abs(dy))return;
      track.style.transition='none';
      track.style.transform='translate3d(calc(-'+(gesture.index*100)+'% + '+dx+'px),0,0)';
      if(event.cancelable)event.preventDefault();
    });
    stage.addEventListener('pointerup',function(event){finish(event,false);});
    stage.addEventListener('pointercancel',function(event){finish(event,true);});
    stage.addEventListener('lostpointercapture',function(event){finish(event,true);});
    show(active);
  }

  function init(root){
    if(root.dataset.ppcReady)return;
    root.dataset.ppcReady='true';
    var heroVideo=root.querySelector('.ppc-hero__video');
    if(heroVideo){
      var motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      var syncVideo=function(){
        if(!motion.matches)heroVideo.play().catch(function(){});
        else heroVideo.pause();
      };
      syncVideo();
      motion.addEventListener('change',syncVideo);
    }
    var demoVideo=root.querySelector('.ppc-demo__video video');
    if(demoVideo){
      var reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
      var syncDemo=function(){
        if(reducedMotion.matches)demoVideo.pause();
        else demoVideo.play().catch(function(){});
      };
      syncDemo();
      reducedMotion.addEventListener('change',syncDemo);
    }
    var form=root.querySelector('.ppc-product-form');
    if(form){
      form.addEventListener('submit',function(event){
        event.preventDefault();
        var button=form.querySelector('[type="submit"]');
        var message=form.querySelector('.ppc-cart-status');
        if(!button || button.disabled)return;
        var id=form.querySelector('[name="id"]').value;
        var choice=form.querySelector('[name="quantity"]:checked');
        var quantity=choice?Number(choice.value):1;
        if(!id){message.textContent='Selected product unavailable.';return;}
        button.disabled=true;
        button.textContent='Adding…';
        message.textContent='';
        fetch(form.action.replace(/\/?$/,'.js'),{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',
          body:JSON.stringify({items:[{id:Number(id),quantity:quantity}]})
        }).then(function(response){
          if(!response.ok)throw new Error('Cart could not be updated');
          return response.json();
        }).then(function(){
          message.innerHTML='Added to cart. <a href="/cart">View your cart</a>.';
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }).catch(function(){
          message.textContent='Could not add the kit. Please try again.';
        }).finally(function(){
          button.textContent='Add to cart';
          button.disabled=false;
        });
      });
    }
    var gallery=root.querySelector('.ppc-offer__gallery');
    if(gallery){
      var swipeTrack=gallery.querySelector('.ppc-offer__track');
      if(swipeTrack){
        initProductGallerySwipe(gallery,swipeTrack);
      }else{
      var featured=gallery.querySelector('.ppc-offer__stage img');
      var thumbs=Array.from(gallery.querySelectorAll('.ppc-offer__thumb'));
      var active=0;
      function show(index){
        active=(index+thumbs.length)%thumbs.length;
        var thumb=thumbs[active];
        featured.src=thumb.dataset.image;
        featured.alt=thumb.dataset.alt;
        featured.style.objectFit=thumb.dataset.fit;
        thumbs.forEach(function(item,i){
          item.classList.toggle('is-active',i===active);
          item.setAttribute('aria-pressed',i===active?'true':'false');
        });
      }
      thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){show(i);});});
      var prev=gallery.querySelector('.ppc-offer__arrow--prev');
      var next=gallery.querySelector('.ppc-offer__arrow--next');
      if(prev)prev.addEventListener('click',function(){show(active-1);});
      if(next)next.addEventListener('click',function(){show(active+1);});
      var stage=gallery.querySelector('.ppc-offer__stage');
      if(stage && featured && thumbs.length>1){
        stage.classList.add('is-draggable');
        featured.addEventListener('dragstart',function(e){e.preventDefault();});
        if(window.PointerEvent){
          var pointerId=null,startX=0,startY=0;
          stage.addEventListener('pointerdown',function(e){
            if(e.button!==0 || (e.target.closest && e.target.closest('.ppc-offer__arrow')))return;
            pointerId=e.pointerId;
            startX=e.clientX;
            startY=e.clientY;
            if(e.pointerType==='mouse'){
              stage.classList.add('is-dragging');
              if(stage.setPointerCapture)stage.setPointerCapture(e.pointerId);
            }
          });
          stage.addEventListener('pointerup',function(e){
            if(e.pointerId!==pointerId)return;
            var dx=e.clientX-startX,dy=e.clientY-startY;
            pointerId=null;
            stage.classList.remove('is-dragging');
            if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy))show(active+(dx<0?1:-1));
          });
          stage.addEventListener('pointercancel',function(e){
            if(e.pointerId===pointerId)pointerId=null;
            stage.classList.remove('is-dragging');
          });
        }else{
          var touchStartX=0,touchStartY=0;
          stage.addEventListener('touchstart',function(e){
            touchStartX=e.changedTouches[0].clientX;
            touchStartY=e.changedTouches[0].clientY;
          },{passive:true});
          stage.addEventListener('touchend',function(e){
            var dx=e.changedTouches[0].clientX-touchStartX;
            var dy=e.changedTouches[0].clientY-touchStartY;
            if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy))show(active+(dx<0?1:-1));
          },{passive:true});
        }
      }
      }
    }
  }
  function initAll(){document.querySelectorAll('.ppc-campaign').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll,{once:true});
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();